import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhContentSearchComponent } from './bh-content-search.component';

@NgModule({
  declarations: [
    BhContentSearchComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhContentSearchComponent
  ]
})
export class BhContentSearchComponentModule { }